import React from 'react';

function WhyChooseMeSection() {
  const reasons = [
    {
      title: "Expertise",
      description: "Deep knowledge in modern backend technologies and architectural patterns, ensuring robust development.",
    },
    {
      title: "Problem Solver",
      description: "A track record of tackling complex technical challenges with innovative and efficient problem-solving approaches.",
    },
    {
      title: "Scalability & Performance",
      description: "Dedicated to building systems that are not only functional but also highly scalable and performant."
    }
  ];

  return (
    <section className="bg-bg-dark py-8 border-y border-border-subtle">
      <div className="max-w-6xl mx-auto px-5">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          <div className="md:col-span-1 text-center md:text-left mb-8 md:mb-0">
            <h2 className="text-4xl text-text-white font-bold relative after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-accent-red after:rounded-sm after:bottom-[-15px]">
              Why Choose Me
            </h2>
          </div>

          <div className="md:col-span-2 grid grid-cols-1 lg:grid-cols-3 divide-y lg:divide-y-0 lg:divide-x divide-border-subtle">
            {reasons.map((reason, index) => (
              <div key={index} className="p-6">
                <h3 className="text-2xl text-text-white mb-3 font-semibold">{reason.title}</h3>
                <p className="text-base text-text-gray">{reason.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseMeSection;